import { FC } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';
import { LowerRole } from '@shared/types';

import { useTitleHook } from '../../bugo/hooks/useTitleHook';
import { GiftOrderDashboardPage } from './GiftOrderDashboardPage';

const AgencyAdminGiftDashboardContent: FC = function AgencyAdminGiftDashboardContent() {
  useTitleHook('수익 대시보드');
  return <GiftOrderDashboardPage role={LowerRole.BugoAgencyAdmin} />;
};

export const AgencyAdminGiftDashboardPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1">
      <AgencyAdminGiftDashboardContent />
    </div>
  </div>
);

export default AgencyAdminGiftDashboardPage;
